import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-3">
              Product Categories
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950">
              Explore Spreadsheet Categories
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md">
            Browse through our comprehensive <strong>hipobuy spreadsheet</strong> category system, organized for effortless product discovery.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
              style={{ aspectRatio: '4/3' }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent z-10"></div>
              <img
                src={cat.imageUrl}
                alt={`${cat.name} category in hipobuy spreadsheet`}
                title={`${cat.name} - Hipobuy Spreadsheet Category`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-0 left-0 right-0 z-20 p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20">
                    <i className={`${cat.icon} text-sm text-white`}></i>
                  </span>
                  <span className="text-white font-medium text-sm md:text-base whitespace-nowrap">{cat.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}